'use strict';

(function () {
  angular.module('zp').constant('searchBackgroundConfig', {
    "default": "/images/banner1.jpg",
    "Vojvodina": "/images/vojvodina.jpg",
    "Mačva District": "/images/macvadistrict.jpg"
  });
})();